import {supabase} from'../api/supabaseClient.js';

function client(){if(!supabase)throw new Error('Supabase frontend environment is not configured.');return supabase;}
const label=v=>String(v||'').replaceAll('_',' ').toLowerCase();

export function buildSectorTurnAlert(event,userId){
 const type=String(event?.eventType||'');
 const weak=type==='TURNED_WEAK';
 const healthy=type==='TURNED_HEALTHY';
 if(!userId||(!weak&&!healthy)||!event?.eventKey||!event?.sectorName)return null;
 const severity=weak?(event.severity==='HIGH'?'HIGH':'MEDIUM'):'LOW';
 return{
  user_id:userId,
  alert_key:`sector-turn:${event.eventKey}`,
  title:`${event.sectorName} ${weak?'turned weak':'turned healthy'}`,
  reason:event.reason||`Verified sector breadth ${label(type)}.`,
  severity,
  status:'OPEN',
  created_at:event.asOf||new Date().toISOString(),
  resolved_at:null,
  source_event_id:event.eventKey,
  model_key:'sector-turn-v1',
  affected_tickers:null,
  why_it_matters:weak?'Sector breadth changed from not weak to weak. Review whether owned or watched companies are being pulled by sector conditions rather than company-specific evidence.':'Sector breadth changed from weak to not weak. Improvement is context only and does not create an entry signal.',
  recommended_check:weak?'Check portfolio/watchlist exposure to this sector and compare company-vs-sector behavior.':'Check whether the improvement persists across the next verified snapshots before changing a thesis.',
  is_read:false
 };
}

export async function syncSectorTurnAlerts(sectorTurns){
 if(String(sectorTurns?.status||'').toUpperCase()!=='LIVE')return{created:0,records:[],status:'SKIPPED_NOT_LIVE'};
 const events=Array.isArray(sectorTurns?.events)?sectorTurns.events:[];
 if(!events.length)return{created:0,records:[],status:'NO_EVENTS'};
 const c=client(),{data:userData,error:userError}=await c.auth.getUser();
 if(userError)throw userError;
 const user=userData?.user;if(!user)throw new Error('Authentication required.');
 const records=events.map(e=>buildSectorTurnAlert(e,user.id)).filter(Boolean);
 if(!records.length)return{created:0,records:[],status:'NO_VALID_EVENTS'};
 const{data,error}=await c.from('alert_record').upsert(records,{onConflict:'user_id,alert_key',ignoreDuplicates:true}).select('id,alert_key,title,severity,status,created_at,source_event_id,model_key,is_read');
 if(error)throw error;
 const inserted=data||[];
 return{created:inserted.length,records:inserted,status:'SYNCED'};
}
